/** 客户批量配置 Excel：模版 fileTypeCode / 上传 type */
export const CUSTOMER_CONFIG_EXCEL = {
  /** 客户方完整联系人列表，按客户分组替换。 */
  customerContact: {
    templateFileTypeCode: 'CUSTOMER_CONTACT_TEMPLATE',
    uploadType: 'CUSTOMER_CONTACT',
    templateFileName: '客户联系人批量修改模板.xlsx',
  },
  /** 我方联系人 · 场景规则，相同条件更新。 */
  ourContactRule: {
    templateFileTypeCode: 'CUSTOMER_OUR_CONTACT_RULE_TEMPLATE',
    uploadType: 'OUR_CONTACT_RULE',
    templateFileName: '我方联系人场景规则导入模板.xlsx',
  },
  /** 自动审批 · 默认配置 */
  autoAuditConfig: {
    templateFileTypeCode: 'CUSTOMER_AUTO_AUDIT_CONFIG_TEMPLATE',
    uploadType: 'AUTO_AUDIT_CONFIG',
    templateFileName: '自动审批默认配置批量修改模板.xlsx',
  },
  /** 自动审批 · 场景规则 */
  autoAuditRule: {
    templateFileTypeCode: 'CUSTOMER_AUTO_AUDIT_RULE_TEMPLATE',
    uploadType: 'AUTO_AUDIT_RULE',
    templateFileName: '自动审批场景规则导入模板.xlsx',
  },
  /** 测算开关 · 默认配置 */
  valuationConfig: {
    templateFileTypeCode: 'CUSTOMER_VALUATION_EXECUTION_CONFIG_TEMPLATE',
    uploadType: 'VALUATION_EXECUTION_CONFIG',
    templateFileName: '测算开关默认配置批量修改模板.xlsx',
  },
  /** 测算开关 · 场景规则 */
  valuationRule: {
    templateFileTypeCode: 'CUSTOMER_VALUATION_EXECUTION_RULE_TEMPLATE',
    uploadType: 'VALUATION_EXECUTION_RULE',
    templateFileName: '测算开关场景规则导入模板.xlsx',
  },
} as const;

export type CustomerConfigExcelUploadType =
  (typeof CUSTOMER_CONFIG_EXCEL)[keyof typeof CUSTOMER_CONFIG_EXCEL]['uploadType'];
